import { useState } from 'react';
import { Button, SUB_CONFIRM_LAYER, useConfirmDialog } from '@safetyhub/ui';
import { withDirectionParticle } from '@safetyhub/shared';
import { adminApi } from '../lib/api';

interface Props {
  userId: string;
  userName: string;
}

export default function ImpersonateButton({ userId, userName }: Props) {
  const [loading, setLoading] = useState(false);
  // 사용자 상세(base Modal z-[70]) 안에서만 렌더되므로 확인은 한 층 위(`SUB_CONFIRM_LAYER`).
  const [confirm, confirmDialog] = useConfirmDialog();

  const handleImpersonate = async () => {
    if (
      !(await confirm({
        title: '빙의 확인',
        body: `${withDirectionParticle(userName)} 로그인하시겠습니까?`,
        confirmLabel: '빙의',
        ...SUB_CONFIRM_LAYER,
      }))
    ) {
      return;
    }

    setLoading(true);
    try {
      const response = await adminApi.impersonate(userId);

      if (response.success && response.data) {
        // 새 탭에서 일반 앱 열기 (Impersonation 토큰과 함께)
        const appUrl = import.meta.env.VITE_APP_URL || 'http://localhost:5173';
        const token = response.data.accessToken;

        // 토큰을 URL 파라미터로 전달 (일반 앱에서 처리)
        window.open(
          `${appUrl}/auth/impersonate?token=${encodeURIComponent(token)}`,
          '_blank'
        );
      } else {
        alert(response.error?.message || '빙의에 실패했습니다.');
      }
    } catch {
      alert('빙의 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* 대행 접속은 되돌릴 수 있으나 부수효과가 큰 운영 액션 — warning(amber) 유지. */}
      <Button variant="warning" size="sm" onClick={handleImpersonate} disabled={loading}>
        {loading ? '처리 중...' : '빙의'}
      </Button>
      {confirmDialog}
    </>
  );
}
